import React from "react";

const Home = () => {
  return (
    <div className="backgroundContainer">
      <h1 className="homeTitle">GUILT FREE</h1>
      <h4 className="homeSubtitle">
        A CARBON EMISSIONS CALCULATOR FOR MORE CONSCIOUS JOURNEYS
      </h4>
    </div>
  );
};

export default Home;
